import React from 'react'
import {Block} from 'jsxstyle'

export type LoaderProps = {
  size?: number
  borderWidth?: string
  borderColor?: string
  borderTopColor?: string
}

const Loader: React.FC<LoaderProps> = ({size = 20, borderWidth = '5px', borderColor = '#f3f3f3', borderTopColor = '#1976D2'}) => {
  return (
    <>
      <style>{spinAnimation}</style>
      <Block
        width={size}
        height={size}
        border={`${borderWidth} solid ${borderColor}`}
        borderTop={`${borderWidth} solid ${borderTopColor}`}
        borderRadius="50%"
        style={{
          animation: 'spin 1s linear infinite',
          transformOrigin: 'center center',
        }}
        margin="auto"
        display="flex"
        alignItems="center"
        justifyContent="center"
      />
    </>
  )
}

const spinAnimation = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`

export default Loader
